import { Controller } from "stimulus";

const HELP_URL = "https://help.qualifier.ai/does-qualifier-work-in-germany";

export default class extends Controller {
  static targets = ["input", "notice"];

  static values = { list: Array };

  declare readonly hasInputTarget: boolean;
  declare readonly inputTarget: HTMLInputElement;
  declare readonly hasNoticeTarget: boolean;
  declare readonly noticeTarget: HTMLElement;

  declare readonly listValue: string[];

  connect(): void {
    this.check();
  }

  check(): void {
    const matched = this.matches();

    this.renderNotice(matched);
    this.highlight(matched);
  }

  private matches(): Set<string> {
    if (!this.hasInputTarget || !this.listValue.length) return new Set();

    const disallowed = new Set(this.listValue.map((region) => String(region).toLowerCase()));

    return new Set(
      this.inputTarget.value
        .split(",")
        .map((region) => region.trim().toLowerCase())
        .filter((region) => region && disallowed.has(region))
    );
  }

  private renderNotice(matched: Set<string>): void {
    if (!this.hasNoticeTarget) return;

    this.noticeTarget.textContent = "";
    this.noticeTarget.hidden = matched.size === 0;
    if (!matched.size) return;

    const names = Array.from(matched).map((region) => region.charAt(0).toUpperCase() + region.slice(1));
    this.noticeTarget.append(`Disallowed region(s): ${names.join(", ")}. `);

    const link = document.createElement("a");
    link.href = HELP_URL;
    link.target = "_blank";
    link.rel = "noopener";
    link.textContent = "Read more.";
    this.noticeTarget.appendChild(link);
  }

  private highlight(matched: Set<string>): void {
    this.element.querySelectorAll<HTMLElement>(".choices__list--multiple .choices__item").forEach((item) => {
      const value = (item.dataset.value || "").toLowerCase();
      item.classList.toggle("disallowed-item", matched.has(value));
    });
  }
}
